import { useMutation } from '@tanstack/react-query';
import { AuthApiError } from '@supabase/supabase-js';
import { useLocation } from 'react-router-dom';

import { supabaseClient } from 'src/auth/supabase';
import { routes } from 'src/constants/routes';

import { useCheckIsRebooker } from './use-check-is-rebooker';

export const useVerifyOtpSupabase = () => {
    const location = useLocation();
    const { mutate } = useCheckIsRebooker();

    return useMutation<unknown, AuthApiError, { email: string; token: string }>({
        mutationKey: ['auth', 'otp', 'verify'],
        mutationFn: async ({ email, token }: { email: string; token: string }) => {
            const res = await supabaseClient.auth.verifyOtp({
                type: 'email',
                email,
                token,
            });

            if (res.error) throw res.error;

            return res.data;
        },
        onSuccess: () => {
            if (!location.pathname.includes(routes.yourDetails.index)) return;
            mutate();
        },
    });
};
